<template>
  <div class="container">
    <div class="columns">
      <div class="column is-6"><LsSupportHeader label="Skip next mow" /></div>
    </div>
    <BLoading :active.sync="properties.loadingStatus.isLoading" />
    <div class="columns">
      <div class="column is-6 ls-left-column">
        <p class="intro-text">
          Grass not growing? We're happy to push your service back. Please only skip a service if
          your lawn is not growing. Skipping a mow during the growth season may cause your crew to
          request a long grass fee due to extra time spent mowing
        </p>
      </div>
      <div v-if="!properties.loadingStatus.isLoading && nextMow" class="column ls-right-column">
        <LsInfoCard>
          <p class="info-text">
            We cannot guarantee a rescheduling of service 48 hours before your next scheduled
            service date ({{ nextMow | date }})
          </p>
        </LsInfoCard>
      </div>
    </div>

    <div class="columns">
      <div v-if="!properties.loadingStatus.isLoading" class="column is-6">
        <div class="select-wrapper">
          <LsSelect
            v-model="selectedProperty"
            test-id="properties"
            label="Property to reschedule:"
            name="properties"
            :options="optionsArray"
            track-id="skip_mow_view-properties"
            @input="onSelect"
          />
        </div>
        <div class="info-and-button-wrapper">
          <div class="next-mow-wrapper">
            <div v-if="nextMow">
              <span class="next-mow-upper">Next service if skipped:</span>
              <div class="next-mow-lower">
                <LsIcon type="calendar" test-id="icon" size="md" class="calendar" />
                <span class="date-text" test-id="date_text">{{ nextMow | date }}</span>
              </div>
            </div>
            <p v-else>There are no active subscriptions for this property</p>
          </div>
          <div class="button-wrapper">
            <LsButton
              v-if="nextMow"
              test-id="confirm"
              text="confirm"
              track-id="skip_mow_view-confirm"
              :loading="support.loadingStatus.isUpdating"
              @click="onSubmit"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import {
  SUPPORT__SKIP_MOW,
  PROPERTIES__GET_PROPERTIES_AND_SCHEDULES,
  PROPERTIES__PROPERTIES_IN_ARRAY,
} from '@/store/types';
import { LsSelect, LsInfoCard, LsIcon, LsButton } from '@/components/common';
import _ from 'lodash';
import moment from 'moment';
import { LsSupportHeader } from '../components';

export default {
  name: 'SkipMowView',
  components: { LsSelect, LsInfoCard, LsIcon, LsButton, LsSupportHeader },
  data() {
    return {
      nextMow: null,
      selectedProperty: null,
    };
  },
  computed: {
    ...mapGetters([PROPERTIES__PROPERTIES_IN_ARRAY]),
    ...mapState(['support', 'properties', 'schedules']),
    optionsArray() {
      const options = _.map(this[PROPERTIES__PROPERTIES_IN_ARRAY], (property) => {
        return {
          label: property.street,
          value: {
            property_id: property.property_id,
            active_mowing_schedule_id: property.active_mowing_schedule_id,
          },
        };
      });
      this.onSelect(options[0].value);
      return options;
    },
  },
  created() {
    this[PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]();
  },
  methods: {
    ...mapActions([SUPPORT__SKIP_MOW, PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]),
    onSelect(value) {
      const { schedulesById } = this.schedules;
      this.selectedProperty = value;
      this.nextMow = null;

      if (value.active_mowing_schedule_id) {
        const schedule = schedulesById[value.active_mowing_schedule_id];
        this.nextMow = moment(schedule.next_starts_at)
          .add(schedule.cycle, 'days')
          .format('YYYY-MM-DD');
      }
    },
    onSubmit() {
      const { property_id, active_mowing_schedule_id } = this.selectedProperty;
      this[SUPPORT__SKIP_MOW]({
        property_id,
        active_mowing_schedule_id,
        onSuccess: () => {
          this.onSuccess();
        },
      });
    },
    onSuccess() {
      this.$router.push({
        name: 'support',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.intro-text {
  padding-bottom: 20px;
  border-bottom: 1px solid $primary-light;
}

.select-wrapper {
  padding: 15px 0;
}

.next-mow-wrapper {
  height: 94px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: $primary-light;
  padding: 20px;
}

.next-mow-upper {
  padding-bottom: 5px;
}

.next-mow-lower {
  display: flex;
  align-items: center;
  padding-top: 5px;
}

.calendar {
  transform: translateY(-1px);
}

.date-text {
  color: $primary;
  font-weight: bold;
  padding-left: 6px;
  font-size: $size-3;
}

.button-wrapper {
  padding-top: 15px;
}

.info-text {
  font-style: italic;
}

@media (max-width: $mobile-max-width) {
  .intro-text {
    border-bottom: none;
    padding-bottom: 0;
  }

  .select-wrapper {
    padding: 20px 0 0 0;
    margin: 30px 0;
    border-top: 1px solid $primary-light;
  }

  .button-wrapper {
    padding-top: 30px;
  }
}
.themed-app {
  .intro-text {
    border-color: $theme-color-primary-light;
  }
  .next-mow-wrapper {
    background-color: $theme-color-primary-light;
  }
  .date-text {
    color: $theme-color-primary;
    font-size: $theme-txt-title-sm;
  }
  @media (max-width: $mobile-max-width) {
    .select-wrapper {
      border-color: $theme-color-primary-light;
    }
  }
}
</style>
